import { useState } from "react";
import { CourseIcon, CountryDetailIcon } from "../../common/icons";

type Section = {
  id: string;
  label: string;
};

type TableOfContentProps = {
  sections?: Section[];
  title: string;
  collapsed?: boolean;
  iconType?: number;
};

const TableOfContent = ({
  sections = [],
  collapsed = false,
  title,
  iconType = 1,
}: TableOfContentProps) => {
  const [activeSection, setActiveSection] = useState(sections[0]?.id);

  const getIcon = () => {
    switch (iconType) {
      case 1:
        return <CourseIcon className="fill-primary" />;
      case 2:
        return <CountryDetailIcon />;
      default:
        return <CourseIcon />;
    }
  };

  const handleClick = (sectionId: string) => {
    setActiveSection(sectionId);

    const element = document.getElementById(sectionId);
    if (element) {
      const offset = 80; // Adjust this based on your fixed header height
      const elementPosition =
        element.getBoundingClientRect().top + window.scrollY - offset;

      window.scrollTo({
        top: elementPosition,
        behavior: "smooth",
      });
    }
  };

  return (
    <div className={`filter-container ${collapsed ? "hidden" : "block"}`}>
      <div className="w-full">
        <div className="flex justify-between items-center bg-primary-50 rounded-full">
          <div className="flex items-center gap-6 text-primary font-semibold cursor-pointer px-4 py-2">
            {getIcon()}
            <span className="text-sm">{title}</span>
          </div>
        </div>

        <nav className="space-y-4 my-4">
          {sections.map((item) => (
            <button
              key={item.id}
              onClick={() => handleClick(item.id)}
              className={`w-full flex text-left items-center gap-3 py-3 transition-colors text-sm font-semibold pl-14 ${
                activeSection === item.id
                  ? "text-title border border-[#E8DEF8] rounded-full"
                  : "text-sidebarContent"
              }`}
            >
              {item.label}
            </button>
          ))}
        </nav>

        <hr className="border border-line mb-4" />
      </div>
    </div>
  );
};

export default TableOfContent;
